import { springNeapDays } from '@quicktide/shared'
import type { MessageKey } from '../i18n'

/**
 * Where a day sits in the spring-neap cycle, in the old app's words.
 *
 * `DagenNaSpringtij` counts whole days from the nearest spring tide, negative before and
 * positive after, and calls the far end of that count neaps. Everything in between is
 * phrased against springs rather than against whichever is nearer, which is what the old
 * app did and what its users will be reading for.
 *
 * It matters beyond curiosity: the stream atlas prints a rate for neaps and one for
 * springs, and this is what says which of the two a reader should be looking at.
 */
export function springPhrase(
  time: number,
  springLagDays: number | undefined,
  t: (key: MessageKey) => string,
  tv: (key: MessageKey, value: string) => string
): string {
  const days = springNeapDays(time, springLagDays)
  if (days === 0) return t('springs')
  if (Math.abs(days) === 7) return t('neaps')
  if (days === 1) return t('dayAfterSprings')
  if (days === -1) return t('dayBeforeSprings')
  return days > 0 ? tv('daysAfterSprings', String(days)) : tv('daysBeforeSprings', String(-days))
}
